import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './components';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {
    AuthContextProvider,
    ZoneContextProvider,
    AlertProvider,
    BlastAIContextProvider,
    UserSettingsContextProvider,
} from 'core/contexts';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthContextProvider>
                <ZoneContextProvider>
                    <AlertProvider>
                        <BlastAIContextProvider>
                            <UserSettingsContextProvider>
                                <App />
                            </UserSettingsContextProvider>
                        </BlastAIContextProvider>
                    </AlertProvider>
                </ZoneContextProvider>
            </AuthContextProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
